import React from 'react';
import FormBuilder from '../../../../common/form-builder/FormBuilder';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { usePermission } from '../../../../../contexts/PermissionContext';
import HelpIcon from '../../../../common/help-icon/HelpIcon';
import FormField from '../../../../common/form-field/FormField';

export default function LoiteringConfigForm(
  props: Readonly<{
    buId: string;
  }>
) {
  const { buId } = props;
  const { t } = useTranslation();
  const { findFeature } = usePermission();
  const { control } = useFormContext();

  const loiteringFormConfig = [
    {
      class:
        'col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'maximumSpeed',
      label: t('labels.maximumSpeedLoitering'),
      control: control,
      fieldType: 'number',
      isRequired: true,
      showHelpIcon: true,
      helpText: t('toast.maximumSpeedDesc'),
      maxLength: 100,
      id: 'maximumSpeed',
      allowDecimal: true,
      disabled: buId
        ? !findFeature(
            'BUCompanyConfiguration.EditLoiteringConfigurationSettings'
          )
        : !findFeature(
            'CompanyConfiguration.EditLoiteringConfigurationSettings'
          ),
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
    {
      class:
        'col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'minimumDurationLoitering',
      label: t('labels.minimumDurationOfLoitering'),
      control: control,
      fieldType: 'number',
      isRequired: true,
      showHelpIcon: true,
      allowDecimal: true,
      id: 'minimumDurationLoitering',
      helpText: t('toast.minimumDurationOfLoiteringDesc'),
      maxLength: 100,
      disabled: buId
        ? !findFeature(
            'BUCompanyConfiguration.EditLoiteringConfigurationSettings'
          )
        : !findFeature(
            'CompanyConfiguration.EditLoiteringConfigurationSettings'
          ),
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
    {
      class:
        'col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'aisDataPointsLoitering',
      label: t('labels.aisDataPointsForLoitering'),
      control: control,
      fieldType: 'number',
      allowDecimal: true,
      isRequired: true,
      showHelpIcon: true,
      id: 'aisDataPointsForLoitering',
      helpText: t('toast.aisDataPointsForLoiteringDesc'),
      disabled: buId
        ? !findFeature(
            'BUCompanyConfiguration.EditLoiteringConfigurationSettings'
          )
        : !findFeature(
            'CompanyConfiguration.EditLoiteringConfigurationSettings'
          ),
      maxLength: 100,
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
    {
      class:
        'col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'vesselClusterPointsDistance',
      label: t('labels.vesselClusterPointsDistance'),
      control: control,
      fieldType: 'number',
      isRequired: true,
      showHelpIcon: true,
      id: 'vesselClusterPointsDistance',
      helpText: t('toast.vesselClusterPointsDistanceDesc'),
      disabled: buId
        ? !findFeature(
            'BUCompanyConfiguration.EditLoiteringConfigurationSettings'
          )
        : !findFeature(
            'CompanyConfiguration.EditLoiteringConfigurationSettings'
          ),
      maxLength: 100,
      rules: [
        {
          type: 'required',
          message: t('errors.required'),
        },
      ],
    },
  ];
  return (
    <div className="row">
      <FormBuilder formConfig={loiteringFormConfig} />
      <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 m-l-custom-sixteen-space-col ">
        <div className="mb-btm-space m-c-form-group">
          <label className=" m-l-input-label">
            {t('labels.loiteringRiskRatingLabel')}
            <HelpIcon
              id={'LoiteringRiskRating'}
              helpText={t('toast.loiteringRiskRatingTxt')}
            />
          </label>
        </div>
        <div className="check-box-ais-gap-risk-rating">
          <Controller
            name={'IsLoiteringLowRiskFilter'}
            control={control}
            render={({ field, fieldState }) => (
              <FormField
                config={{
                  class:
                    'col-xl-auto col-lg-auto col-md-4 col-sm-6 col-12 m-l-grid-top-header-list-column  justify-content-start  justify-content-start check-box-padding',
                  name: 'low',
                  label: t('labels.low'),
                  control: control,
                  fieldType: 'checkbox',
                  id: 'low',
                }}
                field={{ ...field }}
                fieldState={{ ...fieldState }}
              />
            )}
          />
          <Controller
            name={'IsLoiteringMediumRiskFilter'}
            control={control}
            render={({ field, fieldState }) => (
              <FormField
                config={{
                  class:
                    'col-xl-auto col-lg-auto col-md-4 col-sm-6 col-12 m-l-grid-top-header-list-column  justify-content-start  justify-content-start check-box-padding',
                  name: 'medium',
                  label: t('labels.medium'),
                  control: control,
                  fieldType: 'checkbox',
                  id: 'medium',
                }}
                field={{ ...field }}
                fieldState={{ ...fieldState }}
              />
            )}
          />
          <Controller
            name={'IsLoiteringHighRiskFilter'}
            control={control}
            render={({ field, fieldState }) => (
              <FormField
                config={{
                  class:
                    'col-xl-auto col-lg-auto col-md-4 col-sm-6 col-12 m-l-grid-top-header-list-column  justify-content-start  justify-content-start check-box-padding',
                  name: 'high',
                  label: t('labels.high'),
                  control: control,
                  fieldType: 'checkbox',
                  id: 'high',
                }}
                field={{ ...field }}
                fieldState={{ ...fieldState }}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}
